import courses from './courses'
import creators from './creators'

const academy = [
	...courses,
	...creators,

	// ── Product Analytics (funil, geografia, tiers, receita) ───────────────────
	{
		path: '/academy/product-analytics',
		name: 'academy-product-analytics',
		component: () => import('@/views/academy/product-analytics/index.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// ── Academy Stats ──────────────────────────────────────────────────────────
	{
		path: '/academy/stats',
		name: 'academy-stats',
		component: () => import('@/views/academy/stats/index.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// ── Technical Assessments ──────────────────────────────────────────────────
	{
		path: '/academy/assessments',
		name: 'academy-assessments-list',
		component: () => import('@/views/academy/assessments/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/assessments/new',
		name: 'academy-assessments-new',
		component: () => import('@/views/academy/assessments/form.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/assessments/generate-ai',
		name: 'academy-assessments-generate-ai',
		component: () => import('@/views/academy/assessments/generate-ai.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/assessments/categories',
		name: 'academy-assessment-categories-list',
		component: () => import('@/views/academy/assessments/categories/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/assessments/certifications',
		name: 'academy-assessments-certifications',
		component: () => import('@/views/academy/assessments/certifications.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/assessments/activity',
		name: 'academy-assessments-activity',
		component: () => import('@/views/academy/assessments/activity.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/assessments/:id/edit',
		name: 'academy-assessments-edit',
		component: () => import('@/views/academy/assessments/form.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// ── Level Up Jobs ─────────────────────────────────────────────────────────
	{
		path: '/academy/level-up-jobs/career-questions',
		name: 'academy-level-up-jobs-career-questions',
		component: () => import('@/views/academy/level-up-jobs/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// ── Career Trails ──────────────────────────────────────────────────────────
	{
		path: '/academy/career-trails',
		name: 'academy-career-trails-list',
		component: () => import('@/views/academy/career-trails/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/career-trails/new',
		name: 'academy-career-trails-new',
		component: () => import('@/views/academy/career-trails/form.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/career-trails/activity',
		name: 'academy-career-trails-activity',
		component: () => import('@/views/academy/career-trails/activity.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/career-trails/:id/edit',
		name: 'academy-career-trails-edit',
		component: () => import('@/views/academy/career-trails/form.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/dashboard',
		name: 'academy-dashboard',
		component: () => import('@/views/academy/dashboard/Index.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// Produtos / Catálogo
	{
		path: '/academy/products',
		name: 'academy-products-list',
		component: () => import('@/views/academy/courses/courses/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/products/moderation',
		name: 'academy-products-moderation',
		component: () => import('@/views/academy/moderation/products.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/products/:id',
		name: 'academy-products-detail',
		component: () => import('@/views/academy/courses/courses/new.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// eBooks
	{
		path: '/academy/ebooks',
		name: 'academy-ebooks-list',
		component: () => import('@/views/academy/ebooks/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/ebooks/new',
		name: 'academy-ebooks-new',
		component: () => import('@/views/academy/ebooks/new.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/ebooks/:id',
		name: 'academy-ebooks-edit',
		component: () => import('@/views/academy/ebooks/new.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// Creators
	{
		path: '/academy/creators',
		name: 'academy-creators-list',
		component: () => import('@/views/academy/creators/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/creators/:id',
		name: 'academy-creators-detail',
		component: () => import('@/views/academy/creators/detail.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// Mentorias
	{
		path: '/academy/mentorships/offers',
		name: 'academy-mentorships-offers-list',
		component: () => import('@/views/academy/mentorships/offers.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/mentorships/sessions',
		name: 'academy-mentorships-sessions-list',
		component: () => import('@/views/academy/mentorships/sessions.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/bookings',
		name: 'academy-bookings-list',
		component: () => import('@/views/academy/bookings/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// Entitlements
	{
		path: '/academy/entitlements',
		name: 'academy-entitlements-list',
		component: () => import('@/views/academy/entitlements/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/entitlements/grant',
		name: 'academy-entitlements-grant',
		component: () => import('@/views/academy/entitlements/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// Certificados
	{
		path: '/academy/certificates/templates',
		name: 'academy-certificate-templates-list',
		component: () => import('@/views/academy/certificates/templates.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/certificates/issued',
		name: 'academy-certificates-issued-list',
		component: () => import('@/views/academy/certificates/issued.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// Avaliações
	{
		path: '/academy/reviews',
		name: 'academy-reviews-moderation',
		component: () => import('@/views/academy/moderation/reviews.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// Reports
	{
		path: '/academy/reports',
		name: 'academy-reports-list',
		component: () => import('@/views/academy/reports/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/report-categories',
		name: 'academy-report-categories-list',
		component: () => import('@/views/academy/reports/categories.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// Promoções
	{
		path: '/academy/promotions',
		name: 'academy-promotions-list',
		component: () => import('@/views/academy/promotions/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// Cupons de Mentores
	{
		path: '/academy/coupons',
		name: 'academy-coupons-list',
		component: () => import('@/views/academy/coupons/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// Comissões
	{
		path: '/academy/commissions',
		name: 'academy-commission-rules-list',
		component: () => import('@/views/academy/commissions/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// Financeiro
	{
		path: '/academy/financial',
		name: 'academy-financial-overview',
		component: () => import('@/views/academy/financial/overview.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/financial/payouts',
		name: 'academy-financial-payouts',
		component: () => import('@/views/academy/financial/payouts.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/refund-requests',
		name: 'academy-refund-requests',
		component: () => import('@/views/academy/refund-requests/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// Insights — job title mappings
	{
		path: '/academy/insights/mappings',
		name: 'academy-insights-mappings',
		component: () => import('@/views/academy/insights/mappings.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},

	// Rotas existentes preservadas
	{
		path: '/academy/services',
		name: 'academy-services',
		component: () => import('@/views/network/blog/posts/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/institutions',
		name: 'institutions',
		component: () => import('@/views/institutions/list.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/messages',
		name: 'academy-messages-list',
		component: () => import('@/views/messages/Messages.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/newsletter',
		name: 'academy-newsletter-list',
		component: () => import('@/views/newsletters/Newsletter.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
	{
		path: '/academy/notifications',
		name: 'academy-notifications-list',
		component: () => import('@/views/notifications/Notifications.vue'),
		meta: { layout: 'content', module: 'MGA,courses' },
	},
]

export default academy
